import styled from 'styled-components';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const ModalContainer = styled.div`
  background: #fff;
  width: 90%;
  max-width: 600px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
`;

export const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #dee2e6;
  background: #f8f9fa;
`;

export const ModalBody = styled.div`
  padding: 16px;
  max-height: 70vh; /* Limita a altura a 70% da altura da viewport */
  max-width: 90vw; /* Limita a altura a 90% da altura da viewport */
  overflow-y: auto; /* Adiciona barra de rolagem vertical */
`;

export const ModalFooter = styled.div`
  padding: 16px;
  border-top: 1px solid #dee2e6;
  text-align: right;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #6c757d;
  transition: color 0.3s ease;

  &:hover {
    color: #495057;
  }
`;